var _rect, _path, _mask, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 35,
    width: 34,
    height: 44,
    rx: 2,
    transform: "rotate(-90 1 35)",
    stroke: "#878787",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 43L18 35L28 35L28 43L18 43Z",
    stroke: "#878787",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 44C7.89543 44 7 43.1046 7 42L39 42C39 43.1046 38.1046 44 37 44L9 44Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 44L39 44L39 40L7 40L7 44ZM37 42L9 42L9 46L37 46L37 42ZM37 42L37 42L37 46C39.2091 46 41 44.2091 41 42L37 42ZM5 42C5 44.2091 6.79086 46 9 46L9 42L9 42L5 42Z",
    fill: "#878787",
    mask: "url(#path-3-inside-1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 31.5,
    width: 27,
    height: 37,
    rx: 0.5,
    transform: "rotate(-90 4.5 31.5)",
    stroke: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.53332b41d4ba9f52235a31f97a5cadc0.svg";
export { ForwardRef as ReactComponent };